<template>
  <div class="equipPlan">
    <div class="next-time">
      <div  class="flex_1">
        <div class="label">{{ $t("Next Service Time") }}</div>
        <div class="value">{{ planList.next_maintenance_date }}</div>
      </div>
      <div  class="flex_1">
        <div class="label">{{ $t("Service Level") }}</div>
        <div class="value">
        {{ (!planList.next_maintenance_item || planList.next_maintenance_item == '-') ? '-' : [
            $t('overview_dynamic.service_type_dict["一级保养"]'),
            $t('overview_dynamic.service_type_dict["二级保养"]'),
            $t('overview_dynamic.service_type_dict["返厂大修"]'),
            $t('overview_dynamic.service_type_dict["日常保养"]'),
          ][
          Number(
              planList.next_maintenance_item
          ) - 1
              ] }}
        </div>
      </div>
    </div>
    <div class="warning-time flex_1">
      <div class="label">{{ $t('Maintenance Items') }}</div>
      <div class="warn-main"  v-if="planList&&planList.maintain_item_data">
          <div  style="color: #00e7ff">{{planList.maintain_item_data.length==0?'-':''}}</div>

          <div
            v-for="(warning, i) in planList.maintain_item_data"
            :key="i"
            class="warn-list"
          >
            <div class="list-value">
              <div class="warn-name" :style="$i18n.locale !== 'ch'&&{fontSize:'13px'}">{{ $t(warning)||'-' }}
              </div>

              <div class="warn-time">
                <span>{{ $i18n.locale === "ch"?"剩":"" }} {{ isPaperMaking ? fixedDays[i]
                :(moment(planList.next_maintenance_date).diff(moment().format('YYYY-MM-DD'), 'day')) }} {{$t('Days')}}</span>

              </div>
            </div>

            <div class="warn_line relative">
              <div
                :class="['speed absolute', 
                speedNumber( 
                  isPaperMaking ? fixedDays[i]
                  :Number((moment(planList.next_maintenance_date).diff(moment().format('YYYY-MM-DD'), 'day')))
                  )]"
                :style="`width:${((( isPaperMaking ? (fixedDays[i] == 540?365:fixedDays[i])
                    :moment(planList.next_maintenance_date).diff(moment().format('YYYY-MM-DD'), 'day')
                  ) / 365) * 100)}%`"
              ></div>
            </div>
          </div>
      </div>
      <div class="warn-main" v-else>
        <div class="warn-list">
            <div class="list-value">
              <div class="warn-name">-</div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {IS_DEMO_PAPER_MAKING_EP1000_ID } from "@/config/common.js";
import _ from "lodash";
export default {
  props: {
    planList: {
      type: Object,
      default: () => {
        return {
          last_maintenance_date:'',
          last_maintenance_item:'',
          last_maintain_item_data:[],
          next_maintenance_date:'',
          next_maintenance_item:'',
          maintain_item_data:[],
        };
      },
    },
    equip_data: {
      type: Object,
      default: () => {
        return {

        };
      },
    },
  },
  data() {
    return {
      backColor: {
        normal: "#7CFFB2",
        warning: "#F8C533",
        error: "#FF706F"
      },
    };
  }, 
  computed: {
    equipData() {
      return _.cloneDeep(this.$store.state.equipManagement.equipData);
    },
    fixedDays(){
      console.log(this.equipData.id == IS_DEMO_PAPER_MAKING_EP1000_ID," this.equip_data.id == IS_DEMO_PAPER_MAKING_EP1000_ID");
      
      return this.equipData.id == IS_DEMO_PAPER_MAKING_EP1000_ID?[60,120,120,90,90,540,60,90]:[15,120,120,30,90,540,15,40];
    },
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    },

  },
  watch:{

  },
  methods: {
    moment,
    speedNumber(s_time) {
      if(this.isPaperMaking){
        if(s_time <= 15){
          return "error";
        }
        if(s_time == 120){
          return "normal";
        }
      }
      if (s_time >= 200) {
        return "normal";
      }
      if (s_time >0  && s_time < 200) {
        return "warning";
      }
      if (s_time <= 0) {
        return "error";
      }
    },

  },
  components: {}
};
</script>

<style scoped lang="scss">
@import url("../../../../../assets/scss/common.scss");
.equipPlan {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-flow: column;

  .next-time {
    display: flex;
    margin-top: 10px;
    .label {
      margin-bottom: 5px;
    }
    .value {
      font-size: 16px;
      line-height: 24px;
      color: #00e7ff;
    }
  }
  .warning-time {
    display: flex;
    flex-flow: column;
    flex: 1;
    margin-top: 10px;
    overflow: hidden;

    .label {
      margin-bottom: 5px;
    }
    .warn-main {
      overflow: auto;
      .warn-list {
        margin-bottom: 10px;
        padding-right: 10px;
        .list-value {
          display: flex;
          .warn-name {
            flex: 1;
            color: #00e7ff;

          }
          .warn-time {
            // flex: 1;
            max-width:100px;
            font-size: 14px;
            text-align: right;
          }
        }
        .warn_line {
          width: 100%;
          height: 5px;
          background-color: #d1d1d1;
          border-radius: 6px;
          margin-top: 5px;
          .speed {
            top: 50%;
            transform: translateY(-50%);
            height: 3px;

            border-radius: 6px;
            &.normal {
              background-color: #00de1e;
            }
            &.warning {
              background-color: #fcc200;
            }
            &.error {
              background-color: #fe2727;
            }
          }
        }
      }
    }
  }
}
/* 隐藏滚动条*/ 
.warn-main::-webkit-scrollbar {
  display: none; /* Chrome Safari */

}
.warn-main{
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none; /* Firefox */
}
</style>
